import type { BaseKeyFunction } from "../../../../../lib/types/baseKeyFunction";

export const keyUsersMeSettings: BaseKeyFunction = () => [
  "users",
  "me",
  "settings",
];
